import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
// biome-ignore lint/style/noRestrictedImports: it's for initialization purpose
import { initReactI18next } from 'react-i18next'
import {
	DEFAULT_LANGUAGE,
	DEFAULT_NAMESPACE,
	DETECTION_CACHES,
	DETECTION_ORDER,
	LANGUAGES,
	RESOURCES,
} from '@/shared/locales/constants.ts'

i18next
	.use(LanguageDetector)
	.use(initReactI18next)
	.init({
		defaultNS: DEFAULT_NAMESPACE,
		detection: {
			caches: DETECTION_CACHES,
			order: DETECTION_ORDER,
		},
		fallbackLng: DEFAULT_LANGUAGE,
		interpolation: {
			escapeValue: false, // React already escapes
		},
		keySeparator: '.',
		react: {
			useSuspense: false,
		},
		resources: RESOURCES,
		supportedLngs: LANGUAGES,
	})
	.then()
